import { useState } from 'react'

import { styled } from 'styled-components'

import { SingleLineWithEllipsis } from '@b-stock/fe-core/bstock-next/components'
import { Tooltip } from '@b-stock/fe-core/bstock-react'
import { Typography } from '@b-stock/fe-core/design-system'

import Image from '@/components/Image'
import type { SearchResult } from '@/queries/listingSearchQuery'

import { getLogoOverride } from '../../marketplaceLogoConfig'

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.5rem;
  flex: 1 0 0;
  height: 1.5rem;

  img {
    max-width: 6.375rem;
    height: 1.5rem;
    width: auto;
    object-fit: contain;
  }
`

const NoLogoFallback = styled(SingleLineWithEllipsis)`
  ${Typography.Body4_Semibold}
  max-width: 6.375rem;
`

const SellerLogoImage = styled.img`
  height: 1.5rem;
  object-fit: contain;
`

const StorefrontLogo = ({ listing }: { listing: SearchResult }) => {
  const overrideLogoUrl = getLogoOverride(listing.siteAbb)
  const vectorLogoUrl = listing.siteVectorLogoUrl
  const [imageElem, setImageElem] = useState<HTMLImageElement | null>(null)

  const logoUrl = overrideLogoUrl || vectorLogoUrl || listing.siteLogoUrl

  return (
    <LogoWrapper>
      {listing.storefrontName ? (
        logoUrl ? (
          <>
            {/* Next.js <Image /> is used on PNG/JPG files and <img /> is used on SVG's */}
            {logoUrl === vectorLogoUrl ? (
              <SellerLogoImage
                ref={setImageElem}
                src={logoUrl}
                data-testid="storefront-logo"
                alt={`${listing.storefrontName} logo`}
              />
            ) : (
              <Image
                ref={setImageElem}
                src={logoUrl}
                data-testid="storefront-logo"
                alt={`${listing.storefrontName} logo`}
                width={102}
                height={24}
              />
            )}
            <Tooltip referenceElement={imageElem}>
              {listing.storefrontName}
            </Tooltip>
          </>
        ) : (
          <NoLogoFallback data-testid="storefront-logo-fallback">
            {listing.storefrontName}
          </NoLogoFallback>
        )
      ) : null}
    </LogoWrapper>
  )
}

export default StorefrontLogo
